import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class LoggingHttpService {
	public constructor(private http: HttpClient) {}
	public log(message: string): void {
		this.http.post('http://localhost:5013/WeatherForecast', { message }).subscribe(
			() => {},
			(error) => {
				/* eslint-disable no-console */
				console.error(error);
			}
		);
	}
}
